<template>
  <div class="padding-md">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="订单号">
            <el-input v-model="searchForm.outTradeNo"></el-input>
          </el-form-item>
          <el-form-item label="商品ID">
            <el-input v-model="searchForm.productId"></el-input>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input v-model="searchForm.userId"></el-input>
          </el-form-item>
          <el-form-item label="商户ID">
            <el-input v-model="searchForm.transactionId"></el-input>
          </el-form-item>
          <el-form-item label="进展">
            <el-select v-model="searchForm.progress" clearable placeholder="请选择">
              <el-option
                v-for="item in orderConfig"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="loadData">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table
          :data="orders"
          :stripe="true"
          v-loading="loading"
          border
          style="width: 100%">
          <el-table-column
            v-if="false"
            prop="id"
            width="80"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="transactionId"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="productId"
            label="商品">
            <template slot-scope="scope">
              <span>{{_find_(products, {id: parseInt(scope.row.productId)}).name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userId"
            label="用户ID">
          </el-table-column>
          <el-table-column
            prop="totalFee"
            label="总费用/元">
            <template slot-scope="scope">
              <span class="text-nowrap">{{scope.row.totalFee | currency }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="outTradeNo"
            label="商户ID">
          </el-table-column>
          <el-table-column
            prop="progress"
            label="订单状态">
            <template slot-scope="scope">
              <span class="text-nowrap">{{Object.assign({}, _find_(orderConfig, {value: scope.row.progress})).label}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="padding-vertical-md"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
          :current-page="pagination.currentPage"
          :page-sizes="pagination.pageSizes"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.dataCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>

  import {
    getOrders,
    getOrderConfig
  } from '@/api/orders';
  import constant from '@/utils/constant';
  import _find_ from 'lodash/find';
  import {getProductsAll} from '../../api/products';

  export default {
    name: 'orders',
    data () {
      return {
        loading: true,
        orders: [],
        orderConfig: [],
        products: [],
        searchForm: {
          outTradeNo: null,
          userId: null,
          productId: null,
          progress: '',
          transactionId: null,
        },
        pagination: {
          currentPage: constant.PAGINATION.currentPage,
          pageSizes: constant.PAGINATION.pageSizes,
          pageSize: constant.PAGINATION.pageSizes[0],
          dataCount: 0,
        }
      };
    },
    /**
     * 初始化钩子
     */
    created () {
      getProductsAll().then(products => {
        this.products = products;
        this.getOrderConfig();
        this.loadData();
      })
    },
    methods: {
      _find_,
      /**
       *查询后端配置
       */
      getOrderConfig () {
        getOrderConfig().then(result => {
          this.orderConfig = result;
        });
      },

      /**
       *加载订单数据
       */
      loadData () {
        this.loading = true;
        getOrders({
          ...this.searchForm,
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }).then(result => {
          this.loading = false;
          this.orders = result.rows;
          if (result.count < this.pagination.pageSize) {
            this.pagination.currentPage = constant.PAGINATION.currentPage
          }
          this.pagination.dataCount = result.count;
        }).catch(() => {
          this.loading = false;
        });
      },
      handleSizeChange (val) {
        this.pagination.pageSize = val;
        this.loadData();
        // 调用查询方法
      },
      handleCurrentChange (val) {
        this.pagination.currentPage = val;
        this.loadData();
        // 调用查询方法
      },
      //上一页
      handlePrevClick () {
        this.pagination.currentPage = this.pagination.currentPage + 1;
      },
      //下一页
      handleNextClick () {
        this.pagination.currentPage = this.pagination.currentPage - 1;
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .update {
    margin-top: 10px;
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .avatar {
      width: 100%;
      height: 100%;
      display: block;
    }
    .img-box {
      width: 100px;
      height: 100px;
    }
    .number-input {
      width: 195px;
    }

    .form-item__full-width .el-select,
    .form-item__full-width .el-input-number {
      width: 100%;
    }

  }
</style>

<style>
  /*这里是elementUI组件自动生成的元素*/

  .el-upload-dragger {
    width: 100px;
    height: 100px;
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }
</style>




// WEBPACK FOOTER //
// orders.vue?94551824